import agroLogo from "../../assets/communities/agro.png";
import artLogo from "../../assets/communities/art.png";
import beautyLogo from "../../assets/communities/beauty.jpeg";
import mktLogo from "../../assets/communities/bold_minds.png";
import bootsLogo from "../../assets/communities/boots.jpeg";
import financeLogo from "../../assets/communities/finance.png";
import realStateLogo from "../../assets/communities/real_state.png";
import techLogo from "../../assets/communities/tech.PNG";

import BoletimSection from "../BoletimSection/BoletimSection";
import CardImageGrid from "../CardImageGrid/CardImageGrid";

function Comunidades({ comunidades, lider }) {
	const COMMUNITIES = [
		{
			desc: `Link Agro${lider && lider.includes("agro") ? ' - Líder' : ''}`,
			image: agroLogo,
			disabled: comunidades.includes("agro") ? false : true,
            show: true,
		},
		{
			desc: `Link Art Dept${lider && lider.includes("artes") ? ' - Líder' : ''}`,
			image: artLogo,
			disabled: comunidades.includes("artes") ? false : true,
            show: true,
		},
		{
			desc: `Beauty Club${lider && lider.includes("beauty") ? ' - Líder' : ''}`,
			image: beautyLogo,
			disabled: comunidades.includes("beauty") ? false : true,
            show: true,
		},
		{
			desc: `Bold Minds${lider && lider.includes("bold_minds") ? ' - Líder' : ''}`,
			image: mktLogo,
			disabled: comunidades.includes("bold_minds") ? false : true,
            show: true,
		},
		{
			desc: `Boots in Business${lider && lider.includes("boots") ? ' - Líder' : ''}`,
			image: bootsLogo,
			disabled: comunidades.includes("boots") ? false : true,
            show: true,
		},
		{
			desc: `Link Finance${lider && lider.includes("finance") ? ' - Líder' : ''}`,
			image: financeLogo,
			disabled: comunidades.includes("finance") ? false : true,
            show: true,
		},
		{
			desc: `Link Real Estate${lider && lider.includes("real_estate") ? ' - Líder' : ''}`,
			image: realStateLogo,
			disabled: comunidades.includes("real_estate") ? false : true,
            show: true,
		},
		{
			desc: `Liga Tech${lider && lider.includes("tech") ? ' - Líder' : ''}`,
			image: techLogo,
			disabled: comunidades.includes("tech") ? false : true,
            show: true,
		},
	];
	return (
		<BoletimSection
			title="Comunidades"
			icon="group"
		>
			<CardImageGrid
				type={"groups"}
				items={COMMUNITIES}
			/>
		</BoletimSection>
	);
}

export default Comunidades;
